export default __webpack_public_path__ + "static/media/4.43615dc3.png";